/**
 * Privacy Policy Page
 */

import { PolicyPage } from './PolicyPage';

const privacyPolicyContent = `FLOWRITHM PRIVACY POLICY (FULL LEGAL DRAFT — 2026)
Operated by Lagori AI LLP
Last Updated: [Insert Date]

1. Introduction
This Privacy Policy ("Policy") describes how FlowRithm, an AI-powered multi-broker algorithmic trading platform operated by Lagori AI LLP, collects, uses, processes, discloses, and protects Personal Data and Non-Personal Data.

This Policy is designed to comply with:
• Digital Personal Data Protection Act, 2023 (India)
• Information Technology Act, 2000 & IT Security Practices Rules
• Applicable SEBI norms for trading ecosystems
• Industry standards (ISO 27001, SOC 2 principles, GDPR-aligned controls)

2. Scope & Applicability
This Policy applies to:
• Retail / B2C Users
• Professional & Advanced Traders
• Advisors / RIAs
• Enterprise / Institutional Clients
• All Interactions (Web, Mobile, APIs, AI systems)

3. Personal Data We Collect
FlowRithm collects the following categories of data:
• Identity & Account Data (Name, Email, Phone, Firebase UID)
• Broker & Integration Data (OAuth tokens, connection logs)
• Trading & Portfolio Data (Holdings, Orders, P&L)
• Strategy & Signals Data (Customer IP - strategy definitions)
• AI Interaction Data (Chat messages, LLM inputs/outputs)
• Technical, Telemetry & Device Data
• Billing & Payment Data

4. How FlowRithm Collects Data
• Directly from users during registration or use
• Through OAuth when connecting brokers
• From brokers via read-only APIs (with explicit user consent)
• Through AI assistant interactions
• Automatically via telemetry (non-sensitive)

5. Purposes of Processing
FlowRithm processes data for:
• Service Delivery (Portfolio aggregation, Multi-broker execution)
• AI Support (Natural language queries, Strategy optimization)
• Account & Authentication
• Security & Risk Management
• Product Improvement
• Compliance

6. Data Security Measures
FlowRithm employs:
• Google Cloud Armor (WAF)
• API Gateway JWT enforcement
• HTTPS/TLS 1.2+ encryption
• AES-256 encryption at rest
• Cloud KMS for all key material
• Secret Manager for token storage

7. Your Rights
Retail & enterprise users may request:
• Access to your data
• Correction of inaccuracies
• Deletion (subject to law)
• Withdrawal of consent
• Export/portability of data
• Grievance redressal

8. Contact Information
For questions, complaints, or access requests:
Lagori AI LLP
Email: contact@flowrithm.trade`;

export function PrivacyPolicyPage() {
  return <PolicyPage title="Privacy Policy" content={privacyPolicyContent} />;
}

